import React from "react";
import Merrco from "src/core/user/components/paymentMethods/Merrco";
import Moneris from "src/core/user/components/paymentMethods/Moneris";
import Stronghold from "src/core/user/components/paymentMethods/Stronghold";

export default function PaymentMethodsSection({
  paymentMethods,
  editAccountRoute,
  editCreditCardsRoute,
}) {
  return (
    <>
      {paymentMethods.stronghold && <Stronghold editAccountRoute={editAccountRoute} />}
      {paymentMethods.merrco && <Merrco editCardRoute={editCreditCardsRoute} />}
      {paymentMethods.moneris && <Moneris editCardRoute={editCreditCardsRoute} />}
    </>
  );
}
